import { customerApi } from './api';

export const studentService = {
  getStudents: async () => {
    const response = await customerApi.get('/students');
    return response.data;
  },

  createStudent: async (data) => {
    const response = await customerApi.post('/students', data);
    return response.data;
  },

  updateStudent: async (id, data) => {
    const response = await customerApi.put(`/students/${id}`, data);
    return response.data;
  },

  deleteStudent: async (id) => {
    const response = await customerApi.delete(`/students/${id}`);
    return response.data;
  },

  getStudent: async (id) => {
    const response = await customerApi.get(`/students/${id}`);
    return response.data;
  },
};
